import { lazy } from 'react';

const CustomPlanificationsCostCenters = lazy(() => import('./CustomPlanificationsCostCenters'));

export default CustomPlanificationsCostCenters;
